import { render, staticRenderFns } from "./requireitem.vue?vue&type=template&id=9f979056&scoped=true&"
import script from "./requireitem.vue?vue&type=script&lang=js&"
export * from "./requireitem.vue?vue&type=script&lang=js&"
import style0 from "./requireitem.vue?vue&type=style&index=0&id=9f979056&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f979056",
  null
  
)

export default component.exports